export default {
  incidents: {
    filterTitle: 'Фильтровать по статусу',
    label: 'Инцидеты',
    actions: {
      report: 'Сообщить',
    },
    status: {
      reported: 'reported',
      all: 'all',
    },
    reports: {
      label: 'Отправленные инциденты',
      new: 'Сообщить об инциденте',
      view: 'Просмотреть инцидент',
      dateOfIncident: 'Дата инцидента',
      department: 'Подразделение',
      category: 'Категория',
      categoryItem: 'Подкатегория',
      description: 'Описание инцидента',
      patient: 'пациент',
      code: 'Код',
      reportedBy: 'Кем сообщено',
      reportedOn: 'Когда сообщено',
      status: 'Статус',
      error: {
        dateRequired: 'Необходимо указать дату.',
        dateMustBeInThePast: 'Дата должна быть в прошлом.',
        departmentRequired: 'Необходимо указать департамент.',
        categoryRequired: 'Необходимо указать категорию',
        categoryItemRequired: 'Необходимо указать подкатегорию',
        descriptionRequired: 'Необходимо указать описание',
      },
    },
  },
}
